<template>
    <div class="set-password">
        <img
            src="/images/logo.png"
            alt="goTenna Pro Management Portal"
            class="logo"
        />

        <form
            data-test-id="privileged-onboarding-form"
            @submit.prevent="updateUser"
        >
            <p class="copy">Please complete your account creation.</p>

            <div class="form-group">
                <label for="name">Name</label>
                <input
                    id="name"
                    v-model="name"
                    data-test-id="privileged-onboarding-name-field"
                    type="text"
                    required
                    maxlength="60"
                />
            </div>

            <div class="form-group">
                <label for="title">Title</label>
                <input
                    id="title"
                    v-model="title"
                    data-test-id="privileged-onboarding-title-field"
                    type="text"
                    required
                    maxlength="60"
                />
            </div>

            <div class="form-group">
                <label for="username">Username</label>
                <input
                    id="username"
                    v-model="username"
                    data-test-id="privileged-onboarding-username-field"
                    type="text"
                    required
                    maxlength="32"
                />
            </div>

            <div class="form-group">
                <label for="password">Password</label>
                <input
                    id="password"
                    v-model="password"
                    data-test-id="privileged-onboarding-password-field"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <div class="form-group">
                <label for="password_confirmation">Confirm Password</label>
                <input
                    id="password_confirmation"
                    v-model="passwordConfirmation"
                    data-test-id="privileged-onboarding-password-confirmation-field"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <form-errors :response="errorResponse"></form-errors>

            <div class="form-group">
                <button
                    type="submit"
                    class="btn"
                    :class="{ active: submitted }"
                    data-test-id="privileged-onboarding-submit-button"
                >
                    <div>Submit</div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'

export default {
    components: {
        FormErrors,
    },

    props: ['token'],

    data() {
        return {
            password: null,
            passwordConfirmation: null,
            name: null,
            title: null,
            username: null,
            submitted: false,
            errorResponse: null,
        }
    },

    mounted() {
        this.$emit('step', 2)
    },

    methods: {
        updateUser() {
            if (this.submitted) {
                return
            }

            this.submitted = true

            this.$http
                .put(`onboarding/privileged/${this.token}/user`, {
                    name: this.name,
                    title: this.title,
                    username: this.username,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                })
                .then(({ data }) => {
                    const privilegedUser = data

                    // A privileged user belongs to no organization, so the
                    // login goes without one; AuthController matches on a
                    // null organization_id.
                    this.$store
                        .dispatch('login', {
                            email: privilegedUser.email,
                            password: this.password,
                        })
                        .then(() => {
                            // The router's ToS guard sends them on to the
                            // terms if they still have to accept them.
                            this.$router.push('/')
                        })
                        .catch(() => {
                            this.submitted = false
                        })
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>
